<template>
  <v-toolbar
    id="core-toolbar"

    flat
    prominent
    style="background: #eee;"
  >
    <div class="v-toolbar-title" >

      <v-toolbar-title
        class="tertiary--text font-weight-light"
      >
        <v-btn
          v-if="responsive"
          class="default v-btn--simple"
          dark
          icon
          @click.stop="onClickBtn"
        >
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
        {{ title }}
      </v-toolbar-title>
    </div>

    <v-spacer />
    <v-toolbar-items style="width: 16%;">
      <v-flex
        align-center
        layout
        py-2
      >
        <v-toolbar-title class="font-weight-thin" style="margin-right:5%">Welcome, {{name}}</v-toolbar-title>

        <v-icon @click="logoutNow()" color="tertiary">mdi-logout</v-icon>
      </v-flex>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>

import {
  mapMutations
} from 'vuex'
import {logout } from "../../api/routes";
export default {
  data: () => ({
    name:sessionStorage.getItem('USER_NAME') || '',
    notifications: [
      'Mike, John responded to your email',
      'You have 5 new tasks',
      'You\'re now a friend with Andrew',
      'Another Notification',
      'Another One'
    ],
    title: null,
    responsive: false,
    responsiveInput: false
  }),

  watch: {
    '$route' (val) {
      this.title = val.name
    }
  },

  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },

  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onClickBtn () {
      this.setDrawer(!this.$store.state.app.drawer)
    },
    onClick () {
      //
    },
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
        this.responsiveInput = false
      } else {
        this.responsive = false
        this.responsiveInput = true
      }
    },
    logoutNow() {
      logout()
              .then(response => {
                sessionStorage.clear()
                this.$toasted.show('You are logout successfully!!')
                this.$router.push('/session/login')
              })
              .catch(error => {
                sessionStorage.clear()
                this.$toasted.show('You are logout successfully!!')
                this.$router.push('/session/login')
              })
              .finally(() => {

              })


    }
  }
}
</script>

<style>
  #core-toolbar a {
    text-decoration: none;
  }
</style>
